import gql from 'graphql-tag';

import client from '../graphqlAPI';

const SEARCH_SPOTIFY_ARTISTS = gql`
  query searchSpotifyArtistsAdmin($term: String!) {
    searchSpotifyArtistsAdmin(term: $term) {
      isAuth
      items { id name image popularity followers genres }
    }
  }
`;

// Live Spotify search for the artist page picker. ps-back stores every result
// in spotify_artists, so whatever is picked is known to the nightly jobs.
const searchSpotifyArtistsAdmin = async (term) => {
  try {
    const result = await client.query({
      query: SEARCH_SPOTIFY_ARTISTS,
      variables: { term },
      errorPolicy: 'all',
      fetchPolicy: 'no-cache',
    });
    return result?.data?.searchSpotifyArtistsAdmin?.items || [];
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: searchSpotifyArtistsAdmin Error: ${error}`);
    return [];
  }
};

export default searchSpotifyArtistsAdmin;
